import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RTC_NAMESPACE } from 'namespace';
import {
  useContentGenerationConfigPageEnabled,
  useHolosPortalFeatureFlag,
} from 'omega-rtc/utils/portal-config';
import NotFoundPage from 'views/not-found/NotFoundPage';

import './ContentConfig.scss';
import ContentGenerationConfigPage from './ContentGenerationConfigPage';
import type { ContentConfigPermissions } from './permissions';
import { getContentConfigPermissions } from './permissions';
import { contentConfigStyleVars } from './theme';

const ContentGenerationConfigStandalonePage = (props: any) => {
  const enabled = useContentGenerationConfigPageEnabled();
  const editsDisabled = useHolosPortalFeatureFlag('disableContentConfigEdits');
  const userPermissions = useSelector(
    (state: any) => state.app && state.app.user && state.app.user.userPermissions,
  );
  const contentConfigPermissions = getContentConfigPermissions(userPermissions);
  const effectivePermissions = useMemo<ContentConfigPermissions>(
    () => (editsDisabled
      ? {
        ...contentConfigPermissions,
        canEditLocally: false,
        canCreate: false,
        canUpdate: false,
        canReview: false,
      }
      : contentConfigPermissions),
    [contentConfigPermissions, editsDisabled],
  );

  if (!enabled || !contentConfigPermissions.canView) {
    return <NotFoundPage {...props} namespace={RTC_NAMESPACE} />;
  }

  return (
    <div className="cc-portal-shell" style={contentConfigStyleVars}>
      <div className="cc-portal">
        <div className="cc-main">
          <ContentGenerationConfigPage
            {...props}
            contentConfigPermissions={effectivePermissions}
          />
        </div>
      </div>
    </div>
  );
};

export default ContentGenerationConfigStandalonePage;
